import { brandStats } from "../../../mocks/homeData";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[88vh] w-full flex-col justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20editorial%20background%20in%20burnt%20orange%20terracotta%20and%20crimson%20tones%20with%20soft%20ink%20splashes%20grainy%20paper%20texture%20and%20subtle%20fabric%20layers%2C%20cinematic%20magazine%20mood%2C%20no%20text%2C%20rich%20depth%2C%20warm%20light&width=1800&height=1200&seq=hero-ember-2026&orientation=landscape"
          alt="9看料热瓜追踪频道炽热暖调背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/40 to-transparent"></div>
      </div>

      {/* Watermark */}
      <span className="pointer-events-none absolute right-4 top-16 hidden font-display text-[22rem] leading-none text-background-50/5 lg:block">
        9
      </span>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 md:px-6 pt-28 pb-14">
        <div className="flex flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <span className="flex h-2 w-2 rounded-full bg-accent-400 animate-pulseSoft"></span>
            今日热瓜实时追踪中
            <span className="font-display text-accent-300">7×24</span>
          </span>

          <h1 className="mt-6 max-w-4xl font-serif text-4xl font-bold leading-tight text-background-50 md:text-6xl">
            大瓜不难追，
            <span className="relative inline-block text-accent-300">
              热度看得清
              <span className="absolute -bottom-2 left-0 h-1 w-full rounded-full bg-accent-400/70"></span>
            </span>
          </h1>

          <p className="mt-7 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            9看料热瓜追踪频道，持续跟进热门大瓜与爆款瓜的发酵动态。栏目化整理热搜话题与热门爆料，
            逐日刷新<span className="font-semibold text-background-50">爆款瓜热度排行</span>，
            从“出了什么事”到“现在吵到哪一步”，帮你牢牢握住每一条瓜的追更坐标。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-fire-fill w-4 h-4 flex items-center justify-center"></i>
              查看今日热度总榜
            </a>
            <a
              href="#about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/35 bg-white/5 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-white/15 cursor-pointer"
            >
              <i className="ri-compass-3-line w-4 h-4 flex items-center justify-center"></i>
              追踪是怎么做的
            </a>
          </div>

          {/* live tags */}
          <div className="mt-9 flex max-w-full flex-wrap items-center gap-2 text-xs text-background-100">
            <span className="text-background-300">正在热议</span>
            <a href="#tracking" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white/10 px-3 py-1 text-background-50 hover:bg-white/20 cursor-pointer transition-colors">
              <i className="ri-focus-3-line w-3 h-3 flex items-center justify-center text-accent-300"></i>综艺名场面刷屏
            </a>
            <a href="#tracking" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white/10 px-3 py-1 text-background-50 hover:bg-white/20 cursor-pointer transition-colors">
              <i className="ri-focus-3-line w-3 h-3 flex items-center justify-center text-accent-300"></i>顶流巡演官宣
            </a>
            <a href="#tracking" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white/10 px-3 py-1 text-background-50 hover:bg-white/20 cursor-pointer transition-colors">
              <i className="ri-focus-3-line w-3 h-3 flex items-center justify-center text-accent-300"></i>赛事爆冷复盘
            </a>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/15 bg-white/10 backdrop-blur sm:grid-cols-4">
          {brandStats.map((s) => (
            <div key={s.label} className="bg-foreground-950/30 px-5 py-4">
              <div className="font-display text-xl md:text-2xl text-accent-300">{s.value}</div>
              <div className="mt-1 text-xs text-background-200">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}